import { VariantsActionTypes } from './constants';
import { VariantsAction } from './actions';

/* =======================
   State Interface
======================= */

interface VariantsState {
    loading: boolean;
    success: boolean;
    error: string | null;
    message: string | null;
}

/* =======================
   Initial State
======================= */

const initialState: VariantsState = {
    loading: false,
    success: false,
    error: null,
    message: null,
};

/* =======================
   Reducer
======================= */

const variantsReducer = (state: VariantsState = initialState, action: VariantsAction): VariantsState => {
    switch (action.type) {
        case VariantsActionTypes.VARIANTS_ADD:
            return {
                ...state,
                loading: true,
                success: false,
                error: null,
                message: null,
            };

        case VariantsActionTypes.VARIANTS_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message,
                error: null,
            };

        case VariantsActionTypes.VARIANTS_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload.error,
                message: null,
            };

        default:
            return state;
    }
};

export default variantsReducer;
